// import compose from 'lodash/fp/compose'
// import { domReady } from '../../utils'

export const enableSelect = el => { if (el) el.removeAttribute("disabled"); };
export const disableSelect = el => { if (el) el.setAttribute("disabled", "disabled"); };

export const clearSelectElTarget = (el, msg) => {
  if (!el) {
    console.warn("clearSelectElTarget: elemento nulo/indefinido");
    return false;
  }
  clearEl(el);
  disableSelect(el);
  el.insertAdjacentHTML("beforeend", `<option value="">${msg}</option>`);
  return true;
};

export const clearEl = el => { if (el) el.innerHTML = ""; };

// export default domReady(compose(enableSelect, disableSelect))
